// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".device-alarm-modal .ant-descriptions[data-v-0d9d90ca] {\n  height: auto;\n}\n.device-alarm-modal .no-data-class[data-v-0d9d90ca] {\n  text-align: center;\n  padding: 20px 0;\n}\n", ""]);
// Exports
module.exports = exports;
